module.exports = __webpack_public_path__ + "static/media/dragging-icon.ef547ad0.svg";